export default "__VITE_ASSET__DO4iBT4V__"